var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "offset-y": "",
        "max-height": "300px",
        "min-width": "300px",
        "max-width": "500px",
        "content-class": "custom-select-menu",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        label: _vm.label,
                        outlined: "",
                        readonly: "",
                        "append-icon": "mdi-menu-down",
                        clearable: _vm.selectedItems.length > 0,
                        "hide-details": "",
                      },
                      on: { "click:clear": _vm.clearAllSelected },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function () {
                              return _vm._l(_vm.selectedItems, function (item) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: item.value,
                                    staticClass: "mr-1 my-1",
                                    attrs: { small: "", close: "" },
                                    on: {
                                      "click:close": function ($event) {
                                        return _vm.deselectItem(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.name) + " ")]
                                )
                              })
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-card",
        [
          !_vm.hasItems
            ? _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "grey--text" },
                            [_vm._v("No items available")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-expansion-panels",
                { attrs: { accordion: "", multiple: "" } },
                _vm._l(_vm.effectiveGroups, function (groupDef) {
                  return _c(
                    "v-expansion-panel",
                    {
                      key: groupDef.value,
                      attrs: { value: _vm.openGroups.includes(groupDef.value) },
                      on: {
                        change: function ($event) {
                          return _vm.toggleGroup(groupDef.value, $event)
                        },
                      },
                    },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(_vm._s(groupDef.title)),
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(
                                _vm.itemsByGroup[groupDef.value],
                                function (item) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: item.value,
                                      class: {
                                        "v-list-item--active primary--text":
                                          _vm.isItemSelected(item),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleItemSelection(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm.isItemSelected(item)
                                        ? _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("mdi-check")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              !_vm.itemsByGroup[groupDef.value] ||
                              _vm.itemsByGroup[groupDef.value].length === 0
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass: "grey--text caption",
                                            },
                                            [_vm._v("No items in this group")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }